<template>
  <div class="statusNav">
    <nav class="statusPages" role="navigation" aria-label="Species Navigation">
        <ul class="list-nonemt-0">
          <template v-for="(val, key) in tabs"  :key="'tab' + key">
            <li v-if="currentTab == key" class="active"><a>{{val.shortLabel}}</a></li>
            <li v-else @click="switchTab(key)"><a>{{val.shortLabel}}</a></li>
          </template>
        </ul>
    </nav>
    <div class="mobileMenu" v-if="Object.keys(tabs).length > 1">
      <button class="subHead">
        {{ tabs[currentTab]?.shortLabel }}
        <svg class="arrowDown">
          <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
        </svg>
      </button>
      <div class="pullDown left">
        <ul>
          <template v-for="(val, key) in tabs"  :key="'tab' + key">
            <li v-if="currentTab == key" class="active"><a>{{val.shortLabel}}</a></li>
            <li v-else @click="switchTab(key)"><a>{{val.shortLabel}}</a></li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { useApp } from '@/composables/state/profileState';

export default {
  name: 'tab-navigation',
  setup (props) {
    const { switchTab, currentTab, tabs } = useApp();
    return {
      tabs,
      switchTab,
      currentTab
    };
  }
}
</script>
<style lang="scss" scoped>
  ul.list-none{
    list-style: none;
  }
</style>
